module.exports = __webpack_public_path__ + "static/media/NISM Exam Date upload Template.49e81f70.xlsx";